// @flow

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import OnLoadingContentView from 'components/OnLoadingContentView';
import OnLoadingContentViewForModal from 'PMT/components/OnLoadingContentViewForModal';
import ViewConstants from 'constants/ViewConstants';
import ApiError from 'PMT/entities/ApiError';
import appHistory from "../history"

class AbstractComponent extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  static propTypes = {
    location: PropTypes.object
  };

  // -- Loading

  showLoading = (callback) => {
    this.setState({
      loading: true
    }, callback);
  };

  hideLoading = () => {
    this.setState({
      loading: false
    });
  };

  isLoading() {
    return !_.isUndefined(this.state.loading) && this.state.loading === true;
  }

  renderLoading(forceDisplay = false) {
    if (!forceDisplay && (_.isNull(this.state) || _.isUndefined(this.state.loading) || this.state.loading === false)) {
      return (<div className="page_loading_hide"></div>);
    }
    return (
      <div className="page_loading_show">
        <div className="page_loading_show__gif">
          <img
            src={ViewConstants.Image.LOADING_BAR}
            role="presentation"
          />
        </div>
      </div>
    );
  }

  renderOnLoadingContent() {
    return (
      <OnLoadingContentView
        displayMessage={!this.isLoading()}
      />
    );
  }

  renderOnLoadingContentForModal() {
    return (
      <OnLoadingContentViewForModal />
    );
  }

  // -- notifications.

  attachApiError(apiError: ApiError) {
    this.setState({
      apiError
    });
  }

  renderLocalizedApiErrorBlock(apiError: ApiError = null) {
    if (_.isNil(apiError) && !_.isNil(this.state)) {
      apiError = this.state.apiError;
    }

    if (_.isNil(apiError)) {
      return (null);
    }

    return (
      <div className="simple_error_block">
        {apiError.localizedMessage || apiError.message}
      </div>
    );
  }

  /**
   * Note: Assume that there is an apiError object on the state.
   * @param func
   * @returns {*}
   */
  renderApiErrorBlock(apiError: ApiError = null) {
    return this.renderLocalizedApiErrorBlock(apiError);
  }

  get apiError(): ApiError {
    return this.state.apiError;
  }

  /**
   * Returns the query params of the current location.
   * If null returns an empty object.
   */
  get queryParams(): URLSearchParams {
    if (!_.isNull(this.props.location)
    && !_.isUndefined(this.props.location)
        && !_.isNull(this.props.location.search)) {
      return new URLSearchParams(this.props.location.search);
    }

    return {};
  }

  /**
   * This function will change the query params of the url.
   * It require the contextType `router`.
   * @param  {[type]} newQueryParams [description]
   * @return {[type]}                [description]
   */
  onChangeQueryUrl = (newQueryParams: Object) => {
    const params = new URLSearchParams(this.props.location.search);

    Object.entries(newQueryParams).forEach(([key, value]) => {
      if (value === undefined || value === null) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    });

    appHistory.replace({
      pathname: this.props.location.pathname,
      search: params.toString() ? `?${params.toString()}` : '',
    });
  };

  //
  // Permissions
  //
  renderPermissionRequired() {
    return (
      <h4>Vous n'avez pas la permission pour cette action</h4>
    );
  }

}

export default AbstractComponent;
